var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"page-header"},[_c('v-layout',[_c('v-flex',[_vm._v(_vm._s(_vm.bannerTitle))]),_vm._t("headerActionItems"),(_vm.currentUser.role === 'Administrator')?_c('AssessmentModeIndicator'):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }